// extracted by mini-css-extract-plugin
export default {"features":"features_features__UO5BM","wrapper":"features_wrapper__V6cQM","title":"features_title__uDFMb","bg":"features_bg__ka8EJ"};